import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React, { useState } from "react";
import "./UtiDialog.css";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import ShiabudForm from "../../documents/dialogForms/shiabud/ShiabudForm";
import { close } from "../../../redux/actions/modalActions";
import { setNotif } from "../../../redux/actions/dataActions";
import TempLic from "../../documents/dialogForms/tempLic/TempLic";
import DocUpload from "../../documents/dialogForms/docUpload/DocUpload";
import Signature from "../../documents/dialogForms/signature/Signature";
import DialogInfo from "./dialog_info/DialogInfo";
import Download from "../../documents/dialogForms/download/Download";
import { useEffect } from "react";
import TorLink from "../../documents/dialogForms/torLink/TorLink";
import Notification from "../../notification/Notification";
import AccountData from "../../documents/data/AccountData";
const UtiDialog = (props) => {
  const dispatch = useDispatch();
  const { current_doc } = useSelector((state) => state.data);
  const { modal_name } = useSelector((state) => state.modal);
  const { data } = useSelector((state) => state.data);

  const [titles, setTitles] = useState({
    shiabud_form: "שליחת בקשה לטופס שיעבוד",
    temp_lic: "שליחת בקשה להנפקת רישיון זמני",
    DocUpload: current_doc ? current_doc.label : "העלאת מסמכים",
    account_data: "פרטי חשבון",
    download: "הורדת מסמכים",
    torLink: "תיאום תור למסירה",
    sign: "חתימה על מסמכים"
  });
  useEffect(() => {
    setTitles({
      shiabud_form: "שליחת בקשה לטופס שיעבוד",
      temp_lic: "שליחת בקשה להנפקת רישיון זמני",
      DocUpload: current_doc ? current_doc.label : "העלאת מסמכים",
      account_data: "פרטי חשבון",
      download: "הורדת מסמכים",
      torLink: "תיאום תור למסירה",
      sign: "חתימה על מסמכים",
      notif: "הודעה"
    });
  }, [current_doc]);
  const getContent = () => {
    switch (modal_name) {
      case "shiabud_form":
        return <ShiabudForm />;
      case "temp_lic":
        return <TempLic />;
      case "DocUpload":
        return <DocUpload />;
      case "sign":
        return <Signature />;
      case "download":
        return <Download />;
      case "torLink":
        return <TorLink />;
      case "account_data":
        return <AccountData />;
      case "notif" : 
        return <Notification data={data} popup={true}/>;
    }
  };
  const handleClose = () => {
    if (modal_name === 'notif') {
      dispatch(setNotif({step: data?.notificationStep, docNum: data?.id, lic_num:data?.truckData?.licNum }));
    }
    dispatch(close());
  };

  return (
    <div>
      <Dialog open={!!modal_name}>
        <DialogTitle className="dialog_title">
          {titles[modal_name]}
          <IconButton
            className="close_icon"
            aria-label="close"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="uti_dialog">
          {/* <DialogInfo /> */}
          <div className="center"> {getContent()}</div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UtiDialog;
